import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router'
import { Card, Col, Row, Container } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import * as fromActions from 'store/actions/participants.action'
import { IMainState } from 'store/states'
import Loader from 'components/ui/loader/Loader'
import styles from './User.module.scss'
import UserInfo from './components/user-info/UserInfo'
import CourseInfo from './components/courses-info/CourseInfo'

interface Params {
  userId: string
}

const User: React.FC = () => {
  const dispatch = useDispatch()

  const { userId } = useParams<Params>()
  const [showPermissionsModal, setShowPermissionsModal] = useState(false)

  const { participant, participantCourses, loading } = useSelector(
    ({ participants }: IMainState) => participants
  )

  useEffect(() => {
    if (userId)
      dispatch({ type: fromActions.PARTICIPANTS_PROFILES_GET, payload: userId })
  }, [dispatch, userId])


  useEffect(() => {
    dispatch({ type: fromActions.PARTICIPANTS_GET_COURSES, payload: userId })
  }, [dispatch, participant.lmsProfiles, userId])

  return loading ? (
    <Loader overlay color />
  ) : (
    <>
      <Container fluid className="pt-4">
        <Row className="pb-3">
          {/* Left side */}
          <Col lg={3} className={`pl-4 d-flex justify-content-center `}>
            <div className={`${styles.userInfoContainer}`}>
              <UserInfo
                  data={participant}
                  setShowPermissionsModal={setShowPermissionsModal} 
              />
            </div>
          </Col>
          {/* Right side */}
          <Col className="pr-4">
            <Card className={`w-100 pr-4 ${styles.container}`}>
              <Card.Body className="p-4 w-100">
                <CourseInfo
                  data={participantCourses}
                  setShowPermissionsModal={setShowPermissionsModal}
                  showPermissionsModal={showPermissionsModal}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default User
